module.exports = __webpack_public_path__ + "static/media/S (198).dc33c8a4.jpg";